import close_icon_purple from 'src/assets/close_icon_purple.png'

import { useContext, useEffect, useState } from 'react'

import { AnimatePresence } from 'framer-motion'
import sittingMeditationAnimation from 'src/consumer/lotties/sittingMeditation.json'
import FormNavbar from './components/FormNavbar'

import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import learnMeditation from 'src/assets/learnMeditation.png'
import mentalHealth from 'src/assets/mentalHealth.png'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { hasCompletedConsumerOnboarding } from 'src/consumer/helpers/onboardingStatus'
import {
  getFocusAreaOptions,
  getFocusOptions,
  getPreferencesDrawerItems,
} from 'src/consumer/helpers/profilePageHelper'
import { mediaURL } from 'src/consumer/services'
import { getSecureSetupData } from 'src/consumer/services/secureSetupService'
import { getData, postData, putData } from 'src/consumer/services/profileService'
import { isBasicOnboardingDone } from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import ProfessionalsListPage from '../Professionals List Page'
import {
  CustomLottie,
  FormBackground,
  FormBody,
  FormButtonBelowContent,
  FormContent,
  FormContentBody,
  FormContentContainer,
  FormContentHeadings,
  ProfessionalsDrawer,
  QuestionHeading,
  QuestionSubtext,
  QuestionSupertext,
} from './FormStyles'
import {
  FormInfoModalComponent,
  MultiSelectComponentITS,
  NumericInputComponent,
  SingleSelectComponentITSOET,
  SingleSelectComponentOTOGTTH,
  TextInputComponent,
  UnderlineEffectTextComponent,
} from './helpers/componentRenderingHelper'
import {
  prepareDataForPersonalize,
  prepareDataForRegistration,
  prepareDataForUpdate,
} from './helpers/dataHelpers'
import { setAccessTokenExpiry } from 'src/consumer/services/localstorageServices'
import { ClubbedAuthMainComponent } from '../SignIn/ClubbedAuthComponents'

export default function Form({ state }) {
  console.log(state)

  const { refreshProfileData } = useContext(ProfileContext)

  const navigate = useNavigate()
  const { localizedData } = useContext(LocalizationContext)
  const localizedStrings = localizedData?.strings?.onboardingPage
  const redirectAfterLogin = state?.redirectAfterLogin
  const redirectAfterRegistration = state?.redirectAfterRegistration
  const redirectAfterOnboarding = state?.redirectAfterOnboarding
  const redirectTo = state?.redirectTo
  const redirectData = state?.redirectData

  //highly important, data related:
  // Start with emailPasswordPage if no token, otherwise loadingPage
  const [pageState, setPageState] = useState(() => {
    const token = localStorage.getItem('token')
    return token ? 'loadingPage' : 'emailPasswordPage'
  })
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false)
  const [profileData, setProfileData] = useState({}) //may be received from useLocation
  const [secureSetupData, setSecureSetupData] = useState({})
  const [emailPasswordData, setEmailPasswordData] = useState({ email: '', password: '' })
  const [basicData, setBasicData] = useState({})
  const [personalizationData, setPersonalizationData] = useState({})
  const [oneOnOneMentorsData, setOneOnOneMentorsData] = useState([])
  const [selectedFlow, setSelectedFlow] = useState()

  const [tempCountAPICall, setTempCountAPICall] = useState(1) // temporary

  async function updateSecureSetupData() {
    setSecureSetupData({})
    const response = await getSecureSetupData({
      preferOptimizedWebVariant: true,
    })
    if (response?.status === 200) {
      setSecureSetupData(response?.data)
    } else {
      console.log('error getting secure setup data')
      if (tempCountAPICall < 8) {
        await new Promise((resolve) => setTimeout(resolve, 1500)) // waiting 1.5 sec
        setTempCountAPICall((prev) => prev + 1) // temporary, calling
        updateSecureSetupData()
      }
    }
  }

  async function updateOneOnOneMentorsData() {
    const response = await getData('/api/external/mentor/1on1/list')
    if (response?.status === 200) {
      setOneOnOneMentorsData(response?.data)
    } else {
      console.log('error getting one one one mentors')
    }
  }

  async function pageSetup() {
    const token = localStorage.getItem('token')
    if (token) {
      setPageState('loadingPage')
      await updateSecureSetupData()

      if (Object.keys(profileData).length === 0) {
        try {
          const response = await getData('/api/secure/user/profile')
          updateOneOnOneMentorsData() // knowigly not awaiting here, non blocking  call
          if (response?.status === 200) {
            setProfileData(response?.data)
            if (hasCompletedConsumerOnboarding(response?.data)) {
              navigate('/', {})
            } else if (!isBasicOnboardingDone(response?.data)) {
              setPageState('namePage')
            } else {
              setPageState('pathSelectionPage')
            }
          } else {
            console.log('error getting profile data')
            // If there's an error, show email password page
            setPageState('emailPasswordPage')
          }
        } catch (error) {
          console.log('error getting profile data:', error)
          // If there's an error, show email password page
          setPageState('emailPasswordPage')
        }
      }
    } else {
      setPageState('emailPasswordPage')
    }
  } //function to handle first loading of page, in any case, refresh or coming from another page, it redirects to the right page

  useEffect(() => {
    pageSetup()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // page first load, refresh or comin from some other page

  //visibility related :

  const [animationForward, setAnimationForward] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)
  const [professionalsDrawerOpen, setProfessionalsDrawerOpen] = useState(false)
  const whyWeAskVisiblePages = []
  const backButtonVisiblePages = [
    'agePage',
    'genderPage',
    'contentLanguagesPage',
    'wantProfessionalPage',
    'flowSelectionForMentor',
    'focusAreasSelectionPage',
    'categorySelectionPage',
    'acquisitionMethodSelectionPage',
  ]
  const continueButtonVisiblePages = [
    'contentLanguagesPage',
    'focusAreasSelectionPage',
    'categorySelectionPage',
    'acquisitionMethodSelectionPage',
  ]
  const languageSelectVisiblePages = ['namePage', 'agePage', 'genderPage', 'contentLanguagesPage']

  let previousPageId
  let fillField
  let nextPageId

  switch (pageState) {
    case 'namePage':
      previousPageId = null
      fillField = 'name'
      nextPageId = 'agePage'
      break
    case 'agePage':
      previousPageId = 'namePage'
      fillField = 'age'
      nextPageId = 'genderPage'
      break
    case 'genderPage':
      previousPageId = 'agePage'
      fillField = 'gender'
      nextPageId = 'contentLanguagesPage'
      break
    case 'contentLanguagesPage':
      previousPageId = 'genderPage'
      fillField = 'contentLanguages'
      nextPageId = null
      break

    case 'pathSelectionPage':
      previousPageId = null
      fillField = 'pathSelected'
      nextPageId = 'wantProfessionalPage'
      break
    case 'wantProfessionalPage':
      previousPageId = 'pathSelectionPage'
      fillField = 'wantProfessional'
      nextPageId = null
      break

    case 'flowSelectionForMentor':
      previousPageId = 'wantProfessionalPage'
      fillField = null
      nextPageId = null
      break

    case 'focusAreasSelectionPage':
      previousPageId = 'wantProfessionalPage'
      fillField = 'focusAreasSelected'
      nextPageId = 'categorySelectionPage'
      break
    case 'bodyMindSoulTopicsSelectionPage':
      previousPageId = 'wantProfessionalPage'
      fillField = 'bodyMindSoulTopics'
      nextPageId = 'primaryTopicSelectionPage'
      break
    case 'primaryTopicSelectionPage':
      previousPageId = 'bodyMindSoulTopicsSelectionPage'
      fillField = 'primaryTopic'
      nextPageId = 'categorySelectionPage'
      break

    case 'categorySelectionPage':
      previousPageId = null
      fillField = 'categoriesSelected'
      nextPageId = 'acquisitionMethodSelectionPage'
      break
    case 'acquisitionMethodSelectionPage':
      previousPageId = 'categorySelectionPage'
      fillField = 'acquisitionMethod'
      nextPageId = null
      break

    default:
      break
  }

  function basicDataSetter(data) {
    setBasicData((prev) => ({ ...prev, [fillField]: data }))
  }

  function personalizationDataSetter(data) {
    setPersonalizationData((prev) => ({ ...prev, [fillField]: data }))
  }

  function checkDisabled(emailPasswordData, basicData, personalizationData) {
    if (submitButtonLoading) {
      return true
    }
    if (pageState === 'contentLanguagesPage' || pageState === 'focusAreasSelectionPage') {
      if (Object.keys(secureSetupData).length === 0) {
        return true
      }
    }
    if (pageState === 'emailPasswordPage') {
      if (
        emailPasswordData?.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) &&
        emailPasswordData?.password?.length >= 6
      ) {
        return false
      }
      return true
    }
    if (
      pageState === 'genderPage' ||
      pageState === 'pathSelectionPage' ||
      pageState === 'wantProfessionalPage' ||
      pageState === 'acquisitionMethodSelectionPage'
    ) {
      if (basicData?.[fillField] || personalizationData?.[fillField]) {
        return false
      } else {
        return true
      }
    }
    if (pageState === 'contentLanguagesPage') {
      if (Array.isArray(basicData?.contentLanguages) && basicData?.contentLanguages?.length !== 0) {
        return false
      } else {
        return true
      }
    }
    if (pageState === 'focusAreasSelectionPage') {
      if (
        Array.isArray(personalizationData?.focusAreasSelected) &&
        personalizationData?.focusAreasSelected?.length !== 0
      ) {
        return false
      } else {
        return true
      }
    }
    if (pageState === 'categorySelectionPage') {
      if (
        Array.isArray(personalizationData?.categoriesSelected) &&
        personalizationData?.categoriesSelected?.length !== 0
      ) {
        return false
      } else {
        return true
      }
    }

    return false
  }

  async function continueAfterAuthentication(receivedProfileData) {
    const nextProfileData = receivedProfileData || {}
    setSubmitButtonLoading(false)
    setPageState('loadingPage')
    setProfileData(nextProfileData)
    await updateSecureSetupData()
    updateOneOnOneMentorsData()

    if (hasCompletedConsumerOnboarding(nextProfileData)) {
      navigate('/', {})
      return
    }

    if (!isBasicOnboardingDone(nextProfileData)) {
      setPageState('namePage')
      return
    }

    setPageState('pathSelectionPage')
  }

  function getOptionsForContentLanguages(secureSetupData) {
    let langArray = []

    secureSetupData?.contentLanguages?.forEach((item) => {
      langArray?.push({
        value: item?.id,
        title: item?.localLanguageName,
        subtext: item?.language,
        image: `${mediaURL}${item?.coverIcon}`,
        preselected: item?.preselected || item?.id === sessionStorage.getItem('languageCode'),
      })
    })

    return langArray
  }

  const focusAreaOptions = getFocusAreaOptions(secureSetupData)
  const { mindAndBodyItems, beingAndBeyongItems } = getFocusOptions(secureSetupData)
  const isFocusAreaEnabled = focusAreaOptions && focusAreaOptions?.length

  function getOptionsForFocusAreas(focusAreaOptions) {
    let focusAreas = []
    focusAreaOptions?.forEach((item) => {
      focusAreas?.push({
        value: item?.id,
        title: item?.title,
        subtext: item?.subtitle,
        image: `${mediaURL}${item?.icon}`,
      })
    })
    return focusAreas
  }

  function getOptionsForContentCategories(secureSetupData) {
    let contentContegories = []
    getPreferencesDrawerItems(secureSetupData)?.forEach((item) => {
      contentContegories?.push({
        value: item?.id,
        title: item?.title,
        subtext: item?.subtitle,
        image: item?.icon ? `${mediaURL}${item?.icon}` : '',
      })
    })
    return contentContegories
  }

  function getOptionsForAcquisitionMethods(secureSetupData) {
    let methodsArray = []
    secureSetupData?.acquisitionPolicy?.web?.forEach((item) => {
      methodsArray?.push({ value: item?.id, label: item?.name })
    })
    return methodsArray
  }

  async function handleBack() {
    setAnimationForward(false)
    if (
      (pageState === 'focusAreasSelectionPage' ||
        pageState === 'bodyMindSoulTopicsSelectionPage') &&
      (getAllRolesInBoolean().isCreator || getAllRolesInBoolean().isTeacher)
    ) {
      // skipping prev step because took decision for the mentor/creator ourselves
      setPageState('pathSelectionPage')
    } else if (
      (pageState === 'focusAreasSelectionPage' ||
        pageState === 'bodyMindSoulTopicsSelectionPage') &&
      personalizationData?.wantProfessional === 'self'
    ) {
      setPageState('flowSelectionForMentor')
    } else if (pageState === 'categorySelectionPage') {
      if (isFocusAreaEnabled) {
        setPageState('focusAreasSelectionPage')
      } else {
        setPageState('bodyMindSoulTopicsSelectionPage')
      }
    } else {
      setPageState(previousPageId)
    }
  }

  async function handleSubmit() {
    setAnimationForward(true)
    if (pageState === 'emailPasswordPage') {
      if (!checkDisabled(emailPasswordData, basicData, personalizationData)) {
        setSubmitButtonLoading(true)
        const payload = prepareDataForRegistration(emailPasswordData)
        const response = await postData('/api/user/registration', payload)
        if (response.status === 200) {
          localStorage.setItem('token', response?.data?.accessToken)
          setAccessTokenExpiry({ accessTokenExpiry: response.data.accessTokenExpiry })
          localStorage.setItem('authorities', JSON.stringify(response?.data?.authorities))
          setSubmitButtonLoading(false)
          updateSecureSetupData() // knowigly not awaiting here, non blocking setup api call
          updateOneOnOneMentorsData() // knowigly not awaiting here, non blocking  call
          setPageState('namePage')
          setProfileData(response?.data)
        } else if (response.message === 'Request failed with status code 403') {
          alert('Already a User, Please Sign In')
          if (redirectAfterLogin) {
            navigate('/login', { state: { ...state } })
          } else {
            navigate('/login', {})
          }
        } else {
          setSubmitButtonLoading(false)
          alert('Please try again')
        }
      }
    } else if (pageState === 'contentLanguagesPage') {
      setSubmitButtonLoading(true)
      const payload = prepareDataForUpdate(basicData, profileData)
      const response = await postData('/api/secure/user/update', payload)
      if (response.status === 200) {
        if (redirectAfterRegistration) {
          navigate(redirectTo, { state: { ...state, fromOnboarding: true } })
        }
        if (
          response?.data?.personalize?.studentPersonalize?.onboardExplorePreference?.itemType ===
          null
        ) {
          setSubmitButtonLoading(false)
          updateSecureSetupData()
          setPageState('pathSelectionPage')
          setProfileData(response?.data)
        } else {
          setSubmitButtonLoading(false)
          updateSecureSetupData()
          setPageState('pathSelectionPage')
          setProfileData(response?.data)
        }
      } else {
        setSubmitButtonLoading(false)
        alert('Please try again')
      }
    }

    // skipping next step and taking that decision for the mentor/creator here
    else if (
      pageState === 'pathSelectionPage' &&
      (getAllRolesInBoolean().isCreator || getAllRolesInBoolean().isTeacher)
    ) {
      setPersonalizationData((prev) => ({ ...prev, wantProfessional: 'self' }))
      if (isFocusAreaEnabled) {
        setPageState('focusAreasSelectionPage')
      } else {
        setPageState('bodyMindSoulTopicsSelectionPage')
      }
    } else if (pageState === 'wantProfessionalPage') {
      if (isFocusAreaEnabled) {
        setPageState('focusAreasSelectionPage')
      } else {
        setPageState('bodyMindSoulTopicsSelectionPage')
      }
    } else if (pageState === 'acquisitionMethodSelectionPage') {
      setSubmitButtonLoading(true)
      const payload = prepareDataForPersonalize(personalizationData, profileData)
      const response = await putData(
        '/api/secure/user/personalize',
        payload,
        '&onboardingCompleted=true',
      )
      await refreshProfileData({
        _forceRefresh: true
      })
      setSubmitButtonLoading(false)
      if (response.status === 200) {
        console.log({ redirectAfterOnboarding, state })
        if (redirectAfterOnboarding) {
          navigate(redirectTo, { state: { ...state } })
        } else {
          navigate('/', {
            state: { showPrewallOnHome: secureSetupData?.showPrewallOnHome || false },
          })
        }
      } else {
        alert('Error Updating Details')
      }
    } else {
      setPageState(nextPageId)
    }
  }

  async function handleWantProfessionalSubmit(optionSelected) {
    if (optionSelected === 'yes') {
      if (
        oneOnOneMentorsData &&
        oneOnOneMentorsData?.length > 0 &&
        oneOnOneMentorsData?.some((item) => item?.services?.live)
      ) {
        setProfessionalsDrawerOpen(true)
      } else {
        handleSubmit()
      }
    } else if (optionSelected === 'self') {
      setPageState('flowSelectionForMentor')
    } else {
      handleSubmit()
    }
  }

  async function handleFlowSelectionSubmit(optionSelected) {
    if (optionSelected === 'mentor') {
      navigate('/mentors/apply')
    } else {
      if (isFocusAreaEnabled) {
        setPageState('focusAreasSelectionPage')
      } else {
        setPageState('bodyMindSoulTopicsSelectionPage')
      }
    }
  }

  const LoadingPageComponent = () => {
    return (
      <FormContentContainer>
        <FormContent>
          <FormContentBody>
            <CustomLottie animationData={sittingMeditationAnimation} loop={true} autoPlay={true} />
          </FormContentBody>
        </FormContent>
      </FormContentContainer>
    )
  }

  return (
    <FormBackground>
      <FormNavbar
        goBackFunction={handleBack}
        backVisible={backButtonVisiblePages?.includes(pageState)}
        languageSelectVisible={languageSelectVisiblePages?.includes(pageState)}
        logoutDropDownVisible={pageState !== 'emailPasswordPage'}
      />

      <AnimatePresence initial={false}>
        <FormBody
          initial={{ opacity: 0, x: 0 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 0 }}
          // initial={{ opacity: 0, x: '50%' }}
          // animate={{ opacity: 1, x: 0 }}
          // exit={{ opacity: 0, x: '-50%' }}
          transition={{ duration: 0.5, delay: 0.3 }}
          key={pageState}
          hasContinueButton={continueButtonVisiblePages?.includes(pageState)}
        >
            {pageState === 'loadingPage' && <LoadingPageComponent />}

            {pageState === 'emailPasswordPage' && (
              <FormContentContainer>
                <FormContent>
                  <FormContentBody>
                    <ClubbedAuthMainComponent
                      theme="light"
                      loginVariant={false}
                      preferredLoginInputType="mobile"
                      allowMobileRegistration={true}
                      onAuthenticated={continueAfterAuthentication}
                      loginFieldHeading={localizedStrings?.signin || 'Sign in'}
                    />
                  </FormContentBody>
                </FormContent>
              </FormContentContainer>
            )}

            {pageState === 'namePage' && (
              <FormContentContainer>
                <FormContent>
                  <FormContentHeadings>
                    <QuestionSupertext></QuestionSupertext>
                    <QuestionHeading>{`${
                      localizedStrings?.name_screen_title || 'What would you like to be called'
                    }?`}</QuestionHeading>
                    <QuestionSubtext></QuestionSubtext>
                  </FormContentHeadings>

                  <FormContentBody>
                    <TextInputComponent
                      placeholder={localizedStrings?.enter_your_name || 'Enter your name'}
                      data={basicData?.[fillField]}
                      setDataFunction={basicDataSetter}
                      onSubmitFunction={handleSubmit}
                    />
                  </FormContentBody>
                </FormContent>
              </FormContentContainer>
            )}

            {pageState === 'agePage' && (
              <FormContentContainer>
                <FormContent>
                  <FormContentHeadings>
                    <QuestionSupertext></QuestionSupertext>
                    <QuestionHeading>
                      {localizedStrings?.age_screen_title || 'How old are you?'}
                    </QuestionHeading>
                    <QuestionSubtext>
                      {localizedStrings?.age_screen_subtitle ||
                        'We ask so that we can offer reccomendations tailored to you'}
                    </QuestionSubtext>
                  </FormContentHeadings>

                  <FormContentBody>
                    <NumericInputComponent
                      placeholder={localizedStrings?.enter_your_age || 'Enter your age'}
                      data={basicData?.[fillField]}
                      setDataFunction={basicDataSetter}
                      onSubmitFunction={handleSubmit}
                      minValue={12}
                      maxValue={120}
                      tooltip={
                        localizedStrings?.you_should_be_twelve_to_one_twenty_to_use_aumhum ||
                        'You should be 12-120 to use AUMHUM'
                      }
                    />
                  </FormContentBody>
                </FormContent>
              </FormContentContainer>
            )}

            {pageState === 'genderPage' && (
              <FormContentContainer>
                <FormContent>
                  <FormContentHeadings>
                    <QuestionSupertext></QuestionSupertext>
                    <QuestionHeading>
                      {localizedStrings?.gender_screen_title || 'How do you identify?'}
                    </QuestionHeading>
                    <QuestionSubtext>
                      {localizedStrings?.gender_screen_subtitile ||
                        'We ask so that we can offer reccomendations tailored to you'}
                    </QuestionSubtext>
                  </FormContentHeadings>

                  <FormContentBody>
                    <SingleSelectComponentOTOGTTH
                      data={basicData?.[fillField]}
                      setDataFunction={basicDataSetter}
                      fireSubmitOnSelection={true}
                      onSubmitFunction={handleSubmit}
                      options={[
                        { value: 'male', label: localizedStrings?.male || 'Male' },
                        { value: 'female', label: localizedStrings?.female || 'Female' },
                        {
                          value: 'nonBinary',
                          label: localizedStrings?.['non-binary'] || 'Non-Binary',
                        },
                      ]}
                    />
                  </FormContentBody>
                </FormContent>
              </FormContentContainer>
            )}

            {/* can't show next page if secureSetupData state is empty object */}
            {pageState === 'contentLanguagesPage' &&
              (Object.keys(secureSetupData).length !== 0 ? (
                <FormContentContainer>
                  <FormContent>
                    <FormContentHeadings>
                      <QuestionSupertext></QuestionSupertext>
                      <QuestionHeading>
                        {redirectData?.prospectiveMentor
                          ? localizedStrings?.content_langauge_screen_title ||
                            'Languages you would like to offer your services in?'
                          : localizedStrings?.content_langauge_screen_title ||
                            'Languages you want your content in?'}
                      </QuestionHeading>
                      <QuestionSubtext>
                        {localizedStrings?.content_langauge_screen_subtitle ||
                          'Select your preferences'}
                      </QuestionSubtext>
                    </FormContentHeadings>

                    <FormContentBody>
                      <MultiSelectComponentITS
                        data={basicData?.[fillField]}
                        setDataFunction={basicDataSetter}
                        options={getOptionsForContentLanguages(secureSetupData)}
                      />
                    </FormContentBody>
                  </FormContent>
                </FormContentContainer>
              ) : (
                <LoadingPageComponent />
              ))}

            {pageState === 'pathSelectionPage' && (
              <FormContentContainer>
                <FormContent>
                  <FormContentHeadings>
                    <QuestionSupertext>
                      {localizedStrings?.personalization || 'Personalization'}
                    </QuestionSupertext>
                    <QuestionHeading>{`${localizedStrings?.welcome || 'Welcome'} ${
                      profileData.name
                    }, ${
                      localizedStrings?.choose_a_path_screen_title || 'Select a Path'
                    }`}</QuestionHeading>
                    <QuestionSubtext>
                      {localizedStrings?.choose_a_path_screen_subtitle ||
                        'Choose one path to move forward with your journey with AUMHUM'}
                    </QuestionSubtext>
                  </FormContentHeadings>

                  <FormContentBody>
                    <SingleSelectComponentITSOET
                      data={personalizationData?.[fillField]}
                      setDataFunction={personalizationDataSetter}
                      onSubmitFunction={handleSubmit}
                      options={[
                        {
                          value: 'mentalHealth',
                          image: mentalHealth,
                          title:
                            localizedStrings?.dealing_with_shit_in_life ||
                            'Dealing with Things in Life',
                          subtext:
                            localizedStrings?.help_me_improve_my_mental_health_and_wellness ||
                            'Help me improve my mental health and wellness',
                        },
                        {
                          value: 'learnMeditation',
                          image: learnMeditation,
                          title: localizedStrings?.seeking_the_ultimate || 'Seeking the Ultimate',
                          subtext:
                            localizedStrings?.[
                              'build_a meditataion_practice_to_achieve_personal_goals'
                            ] || 'Build a meditation practice to achieve personal goals',
                        },
                      ]}
                    />
                  </FormContentBody>
                </FormContent>
              </FormContentContainer>
            )}

            {/* can't show focus related pages if secureSetupData state is empty object as where next button on the page takes is dependent on secureSetupData*/}
            {pageState === 'wantProfessionalPage' &&
              (Object.keys(secureSetupData).length !== 0 ? (
                <FormContentContainer>
                  <FormContent>
                    <FormContentHeadings>
                      <QuestionSupertext>
                        {localizedStrings?.personalization || 'Personalization'}
                      </QuestionSupertext>
                      <QuestionHeading>
                        {localizedStrings?.content_preferences_screen_title ||
                          'Would you like to work with a Mental Health Professional ?'}
                      </QuestionHeading>
                      <QuestionSubtext></QuestionSubtext>
                    </FormContentHeadings>

                    <FormContentBody>
                      <SingleSelectComponentOTOGTTH
                        data={personalizationData?.[fillField]}
                        setDataFunction={personalizationDataSetter}
                        fireSubmitOnSelection={true}
                        onSubmitFunction={handleWantProfessionalSubmit}
                        options={[
                          { value: 'yes', label: localizedStrings?.yes_i_do || 'Yes, I do' },
                          { value: 'no', label: localizedStrings?.["no_I_don't"] || "No, I don't" },
                          {
                            value: 'not_prefer_to_say',
                            label: localizedStrings?.prefer_not_to_say || 'Prefer not to Say',
                          },
                          {
                            value: 'self',
                            label:
                              localizedStrings?.i_am_a_mental_health_prefessional ||
                              'I am a Mental Health Professional',
                          },
                        ]}
                      />
                    </FormContentBody>
                  </FormContent>

                  {professionalsDrawerOpen && (
                    <ProfessionalsDrawer
                      className="drawer"
                      anchor="bottom"
                      open={professionalsDrawerOpen}
                      transitionDuration={{ enter: 600, exit: 300 }}
                    >
                      <img
                        alt="close_button"
                        src={close_icon_purple}
                        style={{
                          cursor: 'pointer',
                          height: '20px',
                          position: 'absolute',
                          top: '30px',
                          right: '30px',
                        }}
                        onClick={() => {
                          setProfessionalsDrawerOpen(false)
                          handleSubmit()
                        }}
                      />
                      <ProfessionalsListPage
                        setupData={secureSetupData}
                        fromOnboarding
                        oneOnOneMentorsData={oneOnOneMentorsData}
                      />
                    </ProfessionalsDrawer>
                  )}
                </FormContentContainer>
              ) : (
                <LoadingPageComponent />
              ))}

            {pageState === 'flowSelectionForMentor' && (
              <FormContentContainer>
                <FormContent>
                  <FormContentHeadings>
                    <QuestionSupertext>Profile Creation</QuestionSupertext>
                    <QuestionHeading>Which profile do you want to create first?</QuestionHeading>
                    <QuestionSubtext>You can create the other later</QuestionSubtext>
                  </FormContentHeadings>

                  <FormContentBody>
                    <SingleSelectComponentOTOGTTH
                      data={selectedFlow}
                      setDataFunction={(value) => setSelectedFlow(value)}
                      fireSubmitOnSelection={true}
                      onSubmitFunction={handleFlowSelectionSubmit}
                      options={[
                        { value: 'consumer', label: 'Create Consumer Profile' },
                        { value: 'mentor', label: 'Create Mentor Profile' },
                      ]}
                    />
                  </FormContentBody>
                </FormContent>

                {professionalsDrawerOpen && (
                  <ProfessionalsDrawer
                    className="drawer"
                    anchor="bottom"
                    open={professionalsDrawerOpen}
                    transitionDuration={{ enter: 600, exit: 300 }}
                  >
                    <img
                      alt="close_button"
                      src={close_icon_purple}
                      style={{
                        cursor: 'pointer',
                        height: '20px',
                        position: 'absolute',
                        top: '30px',
                        right: '30px',
                      }}
                      onClick={() => {
                        setProfessionalsDrawerOpen(false)
                        handleSubmit()
                      }}
                    />
                    <ProfessionalsListPage
                      setupData={secureSetupData}
                      fromOnboarding
                      oneOnOneMentorsData={oneOnOneMentorsData}
                    />
                  </ProfessionalsDrawer>
                )}
              </FormContentContainer>
            )}

            {pageState === 'focusAreasSelectionPage' && (
              <FormContentContainer>
                <FormContent>
                  <FormContentHeadings>
                    <QuestionSupertext>
                      {localizedStrings?.personalization || 'Personalization'}
                    </QuestionSupertext>
                    <QuestionHeading>
                      {localizedStrings?.select_focus_areas || 'Select Focus Areas'}
                    </QuestionHeading>
                    <QuestionSubtext>
                      {localizedStrings?.content_category_2nd_category_screen_subtitle ||
                        'Select as many as you want'}
                    </QuestionSubtext>
                  </FormContentHeadings>

                  <FormContentBody>
                    <MultiSelectComponentITS
                      data={personalizationData?.[fillField]}
                      setDataFunction={personalizationDataSetter}
                      options={getOptionsForFocusAreas(focusAreaOptions)}
                    />
                  </FormContentBody>
                </FormContent>
              </FormContentContainer>
            )}

            {pageState === 'bodyMindSoulTopicsSelectionPage'}
            {pageState === 'primaryTopicSelectionPage'}

            {pageState === 'categorySelectionPage' && (
              <FormContentContainer>
                <FormContent>
                  <FormContentHeadings>
                    <QuestionSupertext>
                      {localizedStrings?.personalization || 'Personalization'}
                    </QuestionSupertext>
                    <QuestionHeading>
                      {localizedStrings?.content_category_2nd_category_screen_title ||
                        'Select Content Categories'}
                    </QuestionHeading>
                    <QuestionSubtext>
                      {localizedStrings?.content_category_2nd_category_screen_subtitle ||
                        'Select as many as you want'}
                    </QuestionSubtext>
                  </FormContentHeadings>

                  <FormContentBody>
                    <MultiSelectComponentITS
                      data={personalizationData?.[fillField]}
                      setDataFunction={personalizationDataSetter}
                      options={getOptionsForContentCategories(secureSetupData)}
                    />
                  </FormContentBody>
                </FormContent>
              </FormContentContainer>
            )}

            {pageState === 'acquisitionMethodSelectionPage' && (
              <FormContentContainer>
                <FormContent>
                  <FormContentHeadings>
                    <QuestionSupertext>
                      {localizedStrings?.personalization || 'Personalization'}
                    </QuestionSupertext>
                    <QuestionHeading>
                      {localizedStrings?.how_did_you_hear_about_AUMHUM ||
                        'How did you hear about AUMHUM ?'}
                    </QuestionHeading>
                    <QuestionSubtext>
                      {localizedStrings?.select_one || 'Select one'}
                    </QuestionSubtext>
                  </FormContentHeadings>

                  <FormContentBody>
                    <SingleSelectComponentOTOGTTH
                      data={personalizationData?.[fillField]}
                      setDataFunction={personalizationDataSetter}
                      fireSubmitOnSelection={false}
                      onSubmitFunction={handleSubmit}
                      options={getOptionsForAcquisitionMethods(secureSetupData)}
                    />
                  </FormContentBody>
                </FormContent>
              </FormContentContainer>
            )}

            {whyWeAskVisiblePages?.includes(pageState) && (
              <UnderlineEffectTextComponent
                text="Why we ask"
                openModalFunction={() => setModalOpen(true)}
              />
            )}

            {continueButtonVisiblePages?.includes(pageState) && (
              <FormButtonBelowContent
                disabled={checkDisabled(emailPasswordData, basicData, personalizationData)}
                onClick={handleSubmit}
              >
                {submitButtonLoading ? (
                  <Spinner animation="border" variant="light" size="md" />
                ) : (
                  localizedStrings?.continue || 'Continue'
                )}
              </FormButtonBelowContent>
            )}
          </FormBody>

        {modalOpen && <FormInfoModalComponent closeFunction={() => setModalOpen(false)} />}
      </AnimatePresence>
    </FormBackground>
  )
}
